import { BoxArrowDown, CaretDown } from '@phosphor-icons/react'
import { Button, Icon } from '@shopflo/ui'
import React from 'react'
import {
  DEFAULT_ICON,
  DEFAULT_MORE_PLANS_TEXT,
  DEFAULT_OFFER_PILL,
  DEFAULT_RING,
  PREVIEW_TEXT,
  highlightGradient
} from './previewTheme'

export { MORE_PLANS_STRIP, highlightGradient, nudgeTextGradient, ribbonGradient } from './previewTheme'

interface SubscriptionPlanPreviewProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  price?: React.ReactNode
  savings?: React.ReactNode
  morePlansLabel?: string
  onMorePlansClick?: () => void
  colors?: {
    background?: string
    text?: string
    ring?: string
    icon?: string
    stripBackground?: string
    stripText?: string
    savings?: string
  }
}

const SubscriptionPlanPreview: React.FC<SubscriptionPlanPreviewProps> = ({
  title,
  subtitle,
  price,
  savings,
  morePlansLabel,
  onMorePlansClick,
  colors
}) => (
  <div className='isolate flex flex-col'>
    <div
      className='relative z-10 flex h-16 items-center rounded-xl pl-3 pr-2'
      style={{
        backgroundColor: colors?.background || '#FFFFFF',
        boxShadow: `0 1px 1px rgba(10,13,18,0.05), inset 0 0 0 1.5px ${colors?.ring || DEFAULT_RING}`
      }}
    >
      <Icon
        IconComponent={BoxArrowDown}
        size='md'
        className='shrink-0'
        iconProps={{ weight: 'duotone', style: { color: colors?.icon || DEFAULT_ICON, opacity: 0.35 } }}
      />

      <div className='ml-1.5 flex min-w-0 flex-1 flex-col'>
        {title}
        {Boolean(subtitle) && (
          <span
            className={PREVIEW_TEXT.cardSubtitle}
            style={{ color: colors?.text || '#000000', opacity: 0.6 }}
          >
            {subtitle}
          </span>
        )}
      </div>

      {Boolean(price) && (
        <div className='mr-1.5 flex shrink-0 flex-col items-end'>
          <span
            className={PREVIEW_TEXT.cardPrice}
            style={{ color: colors?.text || '#000000', opacity: 0.4 }}
          >
            {price}
          </span>
          {Boolean(savings) && (
            <span
              className={`mt-0.5 flex items-center rounded-full px-1.5 ${PREVIEW_TEXT.offerPill} text-white`}
              style={{ background: colors?.savings || DEFAULT_OFFER_PILL }}
            >
              {savings}
            </span>
          )}
        </div>
      )}

      {Boolean(morePlansLabel) && (
        <Icon
          IconComponent={CaretDown}
          size='xxs'
          className='shrink-0'
          iconProps={{ style: { color: colors?.icon || DEFAULT_ICON, opacity: 0.4 }, weight: 'duotone' }}
        />
      )}
    </div>

    {Boolean(morePlansLabel) && (
      <Button
        id='subscription-preview-more-plans'
        variant='ghost'
        size='sm'
        onClick={onMorePlansClick}
        className={`-mt-3 h-9 w-full items-end justify-center gap-0 rounded-xl px-0 pt-0 pb-1.5 ${PREVIEW_TEXT.morePlans}`}
        style={{
          background: highlightGradient(colors?.stripBackground),
          color: colors?.stripText || DEFAULT_MORE_PLANS_TEXT
        }}
      >
        <span className='flex items-center gap-1'>
          {morePlansLabel}
          <Icon IconComponent={CaretDown} size='xxxs' className='opacity-40' iconProps={{ weight: 'bold' }} />
        </span>
      </Button>
    )}
  </div>
)

export default SubscriptionPlanPreview
